"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Helper = /** @class */ (function () {
    function Helper() {
    }
    Helper.swapMap = function (val) {
        var ret = {};
        for (var key in val) {
            ret[val[key]] = key;
        }
        return ret;
    };
    return Helper;
}());
exports.Helper = Helper;
